/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Signin_BackInputs */

const en_signin_back = /** @type {(inputs: Signin_BackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Back to sign in`)
};

/** @type {(inputs: Signin_BackInputs) => LocalizedString} */
const ar_signin_back = en_signin_back;

/** @type {(inputs: Signin_BackInputs) => LocalizedString} */
const he_signin_back = en_signin_back;

/** @type {(inputs: Signin_BackInputs) => LocalizedString} */
const ur_signin_back = en_signin_back;

/** @type {(inputs: Signin_BackInputs) => LocalizedString} */
const es_signin_back = en_signin_back;

/** @type {(inputs: Signin_BackInputs) => LocalizedString} */
const fr_signin_back = en_signin_back;

/** @type {(inputs: Signin_BackInputs) => LocalizedString} */
const de_signin_back = en_signin_back;

/** @type {(inputs: Signin_BackInputs) => LocalizedString} */
const pt_signin_back = en_signin_back;

/** @type {(inputs: Signin_BackInputs) => LocalizedString} */
const hi_signin_back = en_signin_back;

/** @type {(inputs: Signin_BackInputs) => LocalizedString} */
const bn_signin_back = en_signin_back;

/**
* | output |
* | --- |
* | "Back to sign in" |
*
* @param {Signin_BackInputs} inputs
* @param {{ locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }} options
* @returns {LocalizedString}
*/
export const signin_back = /** @type {((inputs?: Signin_BackInputs, options?: { locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Signin_BackInputs, { locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_signin_back(inputs)
	if (locale === "he") return he_signin_back(inputs)
	if (locale === "ur") return ur_signin_back(inputs)
	if (locale === "es") return es_signin_back(inputs)
	if (locale === "fr") return fr_signin_back(inputs)
	if (locale === "de") return de_signin_back(inputs)
	if (locale === "pt") return pt_signin_back(inputs)
	if (locale === "hi") return hi_signin_back(inputs)
	if (locale === "bn") return bn_signin_back(inputs)
	return /** @type {LocalizedString} */ ("Back to sign in")
});